import * as React from "react";
import { TableBody, TableCell, TableHead, TableRow, Stack, Typography, Pagination, Box, useTheme, Button } from "@mui/material";
import SearchTxtField from "../../../components/SearchTxtField";
import route from "../../../utils/Routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import StyledTableContainer from "../../../components/StyledTableContainer";
import { useState } from "react";
import { formatDateWithJs, formatUserType, isNotEmpty } from "../../../utils/format";
import { useAuthContext } from "../../../context/AuthContext";
import { useQuery } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { useEffect } from "react";
import { customAlert } from "../../../components/notify";
import { getNewProdReqListServ } from "../../../services/newprodreq-service";
import { Add } from "@mui/icons-material";
import { getNavData } from "../../../services/amtc-service";
import constants from "../../../utils/Constants";



function NewProdReqListPage() {
    const theme = useTheme();
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const limit = 9;
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0);
    const userId = ctxtUser?.userId;
    const userType = ctxtUser?.userType;
    const currProj = JSON.parse(localStorage.getItem('currProj') || "{}");

    const { isLoading: isUserLoading, isError: isUserErr, error: userErr, data: userData } = useQuery([QueryKey.comUserProfile, ctxtUser.userId],
        () => getNavData(ctxtUser?.userId, ctxtUser?.isComUser),
        {
            enabled: isNotEmpty(ctxtUser?.userId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });

    const { isLoading, isError, error, data: reqData } = useQuery([QueryKey.newProdReqList, pgNo, isSrchBtnClick, userId],
        () => getNewProdReqListServ({
            limit, pageNumber: pgNo, searchWord, userId, userType,
            deptId: userData?.currProj ? userData?.currProj[0].deptId : null,
            projIdStrg: currProj?.projIdStrg
        }), {
        enabled: getPrReqList(userData, userId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const columns = [
        ...((userType === constants.sourcing || userType === constants.admin || userType === constants.ma) ? [{
            id: 'comName',
            label: "Company",
            align: 'left',
            minWidth: 150
        }] : []),
        {
            id: 'newProdReqIdStrg',
            label: "Request ID",
            align: 'left',
            minWidth: 150
        },
        {
            id: 'cAt',
            label: "Raised Date",
            align: 'left',
            minWidth: 150
        },
        ...(constants.needRequestor ? [{
            id: 'reqName',
            label: "Requestor",
            align: 'left'
        }] : []),
        {
            id: 'apprName',
            label: "End User",
            align: 'left'
        },
        {
            id: 'fpName',
            label: "Contract Focal Point",
            align: 'left'
        },
        {
            id: 'linemgrName',
            label: "Contract Owner",
            align: 'left'
        },
        {
            id: 'currStatus',
            label: "Status",
            align: 'left'
        },
        {
            id: 'uAt',
            label: "Last Updated Date",
            align: 'left',
            minWidth: 150
        },
    ];

    function getPrReqList(userData, userId) {
        if (userType === constants.requestor) {
            if (isNotEmpty(userId)) {
                if (userData?.currProj) {
                    if (userData?.currProj[0].deptId)
                        return true
                }
            }
        }
        if (userType === constants.approver) {
            if (!userData?.currProj)
                return false
            if (!userData?.currProj[0].deptId)
                return false
            return true
        }
        if (userType === constants.focalPoint || userType === constants.lineManager) {
            if (!currProj)
                return false
            if (!currProj?.projIdStrg)
                return false
            return true
        }
        if (userType === constants.sourcing) {
            if (isNotEmpty(userId))
                return true
        }
        if (userType === constants.admin || userType === constants.ma) {
            return true
        }

        return false
    }

    useEffect(() => {
        setLoadingScreen(isUserLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUserLoading]);

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    const handleRowClick = (newProdReqIdStrg) => {
        if (ctxtUser?.isComUser)
            navigate(`${route.cNewProdreqinfo}/?newProdReqId=${newProdReqIdStrg}`);
        else
            navigate(`${route.aNewProdreqinfo}/?newProdReqId=${newProdReqIdStrg}`);
    };

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    function handleAddNewProdReq() {
        navigate(route.cCreateNewProdReq);
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    if (isUserErr) {
        customAlert(userErr);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"} px={2}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1, pl: 1, pr: 3 }} width={"100%"}>
                <Stack width={"33%"} >
                    <Typography sx={{ fontSize: 18, fontWeight: 500, }}>New Product Request List</Typography>
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <SearchTxtField handleOnClear={handleOnClear} searchKeyWord={searchWord} onSearch={onSearch}
                        onBtnClick={onSearchBtnClick} placeholder="Search Request By Id..." />
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                    {ctxtUser?.isComUser && <Button variant='outlined' onClick={handleAddNewProdReq} startIcon={<Add />} sx={{
                        fontSize: 13, ml: 5,
                        color: theme?.palette?.custom?.btn, borderColor: theme?.palette?.custom?.btn, height: 30
                    }}>
                        Create New Product Request</Button>}
                </Stack>
            </Stack>

            {reqData && <StyledTableContainer height={"83%"} isStickyHeader={true}>
                <TableHead>
                    <TableRow >
                        {columns.map((column) => (
                            <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(reqData?.prodReqArr || []).map((i) => {
                        return (
                            <React.Fragment key={i?.id}>
                                <TableRow hover tabIndex={-1} onClick={() => handleRowClick(i?.newProdReqIdStrg)}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, height: 50, cursor: 'pointer' }} >
                                    {columns.map((column) => {
                                        const value = i[column.id];
                                        switch (column.id) {
                                            case "cAt":
                                            case "uAt":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatDateWithJs(value)}
                                                </TableCell>
                                            case "currStatus":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatUserType(value)}
                                                </TableCell>
                                            default:
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {(value === null || value === "" || value === "null") ? "-" : value}
                                                    </TableCell>
                                                );
                                        }
                                    })}
                                </TableRow>
                            </React.Fragment>
                        );
                    })}
                </TableBody>
            </StyledTableContainer>}
            <Stack sx={{ alignItems: "center", mt: 2 }}>
                <Pagination count={Math.ceil(reqData?.totalRowsCount / limit) || 0} color="primary" page={pgNo} onChange={handlePageChange}
                    variant="outlined" shape="rounded" />
            </Stack>
        </Box>
    );
}

export default NewProdReqListPage